var _rect, _rect2, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGoodFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 30,
    height: 30,
    rx: 15,
    fill: "url(#paint0_radial_7983_3222)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 30,
    height: 30,
    rx: 15,
    stroke: "#C28000",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5107 18.117C28.7907 17.6393 28.9554 17.0628 28.9554 16.4699C28.9554 15.5962 28.6084 14.7584 27.9906 14.1406C27.3728 13.5228 26.535 13.1758 25.6613 13.1758C24.7877 13.1758 23.9498 13.5228 23.332 14.1406C22.7142 14.7584 22.3672 15.5962 22.3672 16.4699C22.3672 17.0628 22.5319 17.6393 22.8119 18.117C23.3719 17.1287 24.4425 16.4699 25.6613 16.4699C26.8801 16.4699 27.9507 17.1287 28.5107 18.117Z",
    fill: "#C28000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1875 18.117C17.4675 17.6393 17.6322 17.0628 17.6322 16.4699C17.6322 15.5962 17.2851 14.7584 16.6674 14.1406C16.0496 13.5228 15.2117 13.1758 14.3381 13.1758C13.4644 13.1758 12.6265 13.5228 12.0088 14.1406C11.391 14.7584 11.0439 15.5962 11.0439 16.4699C11.0439 17.0628 11.2087 17.6393 11.4887 18.117C12.0487 17.1287 13.1192 16.4699 14.3381 16.4699C15.5569 16.4699 16.6275 17.1287 17.1875 18.117Z",
    fill: "#C28000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7265 23.0586C27.3924 26.4186 24.1477 28.8233 20.31 28.8233C16.4724 28.8233 13.2112 26.4186 11.8936 23.0586H28.7265Z",
    fill: "#C28000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_7983_3222",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.5 10) rotate(82.3332) scale(26.2345)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFFC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.579521,
    stopColor: "#FFE83B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE83B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoodFill);
export default __webpack_public_path__ + "static/media/IconGoodFill.fab27089d3325e36af97674ef7d533d4.svg";
export { ForwardRef as ReactComponent };